<template>
    <div class="card">
        <div class="card-header">
            <div class="text-center text-lg-left">
                <div class="d-md-flex justify-content-md-between">
                    <h3 class="card-title my-3">
                        Promociones para esta sesión
                    </h3>
                    <div>
                        <ModalCreate
                            @creado="getPromociones()" 
                            :event_id="parseInt(event_id)" 
                            :session_id="parseInt(session_id)"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div :class="['table', { 'expanded': promociones.length <= 3 }]">
                <div class="col-12">
                    <b-table
                        striped
                        hover
                        :items="promociones"
                        :fields="fields"
                    >
                        <template #cell(discount_percent)="data">
                            {{ data.value + '%' }}
                        </template>
                        <template #cell(discount_fixed)="data">
                            {{ data.value | formatear_precio }}
                        </template>
                        <template #cell(status)="data">
                            <span v-if="data.value == 1">
                                <i class="text-green fas fa-check-circle"></i>
                            </span>
                            <span v-else>
                                <i class="text-warning fas fa-pause-circle"></i>
                            </span>
                        </template>
                        <template #cell(opciones)="row">
                            <OpcionesDropdownTableComponent
                                :lastIndex="promociones.length > 3 && row.index >= promociones.length - 3"
                                v-bind:options="[
                                    ...(row.item.status == 0 ? [
                                        {
                                            type: 'action',
                                            action: () => activar(row.item.id),
                                            label: 'Activar',
                                        },
                                    ] : []),
                                    ...(row.item.status == 1 ? [
                                        {
                                            type: 'action',
                                            action: () => desactivar(row.item.id),
                                            label: 'Desactivar',
                                        },
                                    ] : []),
                                ]"
                                class="ml-2"
                            />
                        </template>
                    </b-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ModalCreate from '@/components/backend/eventos/sesiones/promociones/ModalCreate.vue';
    import OpcionesDropdownTableComponent from "@/components/backend/components/OpcionesDropdownTableComponent";

    export default {
        props: ['event_id', 'session_id'],
        data() {
            return {
                sesion: null,
                loading: false,
                promociones: [],
                fields: [
                    { key: 'name', label: 'Nombre' },
                    { key: 'old_event', label: 'Evento pasado' },
                    { key: 'discount_fixed', label: 'Descuento en €' },
                    { key: 'discount_percent', label: 'Descuento en %' },
                    { key: 'status', label: 'Estado' },
                    { key: "opciones", label: "Opciones", class: 'text-center' }
                ]
            }
        },
        created() {
            this.getPromociones();
        },
        methods: {
            getPromociones() {
                this.loading = true

                const params = {
                    filters: {},
                    event_id: this.event_id,
                    session_id: this.session_id,
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.promociones.index'), params).then(res => {
                    this.promociones = res.data.data
                }).finally(() => (this.loading = false))
            },
            activar(promocion_id) {
                const params = {
                    filters: {},
                    event_id: this.event_id,
                    session_id: this.session_id,
                    promocion_id: promocion_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.promociones.activar'), params).then(res => {
                    this.getPromociones();
                })
            },
            desactivar(promocion_id) {
                const params = {
                    filters: {},
                    event_id: this.event_id,
                    session_id: this.session_id,
                    promocion_id: promocion_id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.events.sesiones.promociones.desactivar'), params).then(res => {
                    this.getPromociones();
                })
            }
        },
        components: {
            ModalCreate, OpcionesDropdownTableComponent
        },
    }
</script>
<style scoped>
.table {
    overflow: auto;
}

.table.expanded {
    padding-bottom: 150px !important;
}
</style>